import { Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SkillPercentageProgress from './SkillPercentageProgress';

export type SkillBreakdownEntry = {
  skill: string;
  count: number;
  percentage: number;
};

interface SkillBreakdownDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  closeLabel: string;
  description: string;
  emptyMessage: string;
  entries: SkillBreakdownEntry[];
}

function SkillBreakdownDialog({
  open,
  onClose,
  title,
  closeLabel,
  description,
  emptyMessage,
  entries,
}: SkillBreakdownDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pr: 6 }}>
        {title}
        <IconButton
          aria-label={closeLabel}
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ pt: 1, mb: 2 }}>
          {description}
        </Typography>
        <Stack spacing={1} sx={{ pt: 1 }}>
          {entries.length === 0 ? (
            <Typography color="text.secondary" variant="body2">
              {emptyMessage}
            </Typography>
          ) : (
            entries.map((entry) => (
              <Stack
                key={entry.skill}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Typography variant="body2">{entry.skill}</Typography>
                <SkillPercentageProgress value={entry.percentage} />
              </Stack>
            ))
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default SkillBreakdownDialog;
